import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from 'react-toastify';
const ViewMakeCounterOffer = ({
  BuyerId,
  SellerId,
  onClose,
  TransactionId,
  AnswerComments,
  Offer,
  userId,
  liveCsrfToken,
  t,

}) => {
  //wanted,offer
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [offer, setOffer] = useState([]);
  const [wanted, setWanted] = useState([]);
  const [thisUserCards, setThisUserCards] = useState([]);
  const [sellerCards, setSellerCards] = useState([]);
  const [showSellerCards, setShowSellerCards] = useState(false);
  const [comment, setComment] = useState(AnswerComments);
  const [priceOfferAmount, setPriceOfferAmount] = useState(Offer[0].Price);
  const [HasReset, setHasReset] = useState(false);
  console.log("Offer", Offer);
  function transformCardObject(previousOfferCard) {
    const transformedObject = {
      CardId: previousOfferCard.CardId || 0,
      Name: previousOfferCard.Name || "",
      cardName: previousOfferCard.cardName,
      variationName: previousOfferCard.variationName,
      ConditionCard: previousOfferCard.ConditionCard || "",
      Name: previousOfferCard.Name || "",
      Image: previousOfferCard.Image || "",
      ImageBack: previousOfferCard.ImageBack || "",
      ImageFront: previousOfferCard.ImageFront || "",
      ImageUserBack: previousOfferCard.ImageUserBack || "",
      //ImagesExtra
      Graded: previousOfferCard.Graded || 0,
      Grade: previousOfferCard.Grade || 0,
      GradeCompany: previousOfferCard.GradeCompany || "",
      IsAuto: previousOfferCard.IsAuto || 0,
      IsJersey: previousOfferCard.IsJersey || 0,
      IsPatch: previousOfferCard.IsPatch || 0,
      IsRookie: previousOfferCard.IsRookie || 0,
      IsTribute: previousOfferCard.IsTribute || 0,
      NumberBehind: previousOfferCard.NumberBehind || "",
      Numbered: previousOfferCard.Numbered || 0,
      PlayerId: previousOfferCard.PlayerId || 0,
      YearMade: previousOfferCard.YearMade || 0,
      userCardId: previousOfferCard.usercardsId,
      SetName:previousOfferCard.SetName,
      Price:previousOfferCard.Price,
      // CurrentPlayerId: originalObject.CurrentPlayerId || null,
      // EstimateAVG: originalObject.EstimateAVG || null,
      // EstimateValue: originalObject.EstimateValue || 0,
      // Grade: originalObject.Grade || 0,
      // Add more attributes as needed
    };

    return transformedObject;
  }

  const initialiseOriginalCardOffer = async () => {
    const transformedOffer = await Offer.map(transformCardObject);
    console.log(transformedOffer);
    setOffer(transformedOffer);
  };

  const handleCommentChange = async (event) => {
    await setComment(event.target.value);
  };

  // const fetchMyUserCards = async () => {
  //     try {
  //       const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/tradeplace/getTradingCards/ForTrade/${BuyerId}`);
  //       const json = await res.json();
  //       console.log('thisUserCards ', json)
  //       setThisUserCards(json);
  //     } catch (error) {
  //       console.log('Error fetching card data:', error);
  //     }
  //   };

  const fetchSellerCards = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/api/tradeplace/getTradingCards/ForTrade/${SellerId}`
      , {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      const json = await res.json();
      console.log("lisitngUsercards ", json);
      setSellerCards(json);
    } catch (error) {
      console.log("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    fetchSellerCards();
    //fetchMyUserCards();
    initialiseOriginalCardOffer();
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setOffer([]);
    onClose();
  };

  const calculateTradeValueSum = (cards) => {
    return cards.reduce((sum, card) => sum + card.tradeValue, 0);
  };

  const getOfferValueSum = () => {
    return calculateTradeValueSum(offer);
  };

  // Function to get the sum of tradeValues for the wanted cards
  const getWantedValueSum = () => {
    return calculateTradeValueSum(wanted);
  };

  const handleCardSelect = (selectedCard) => {
    console.log("am trying to select this card", selectedCard);
    if (selectedCard.UserId === SellerId) {
      console.log("I am this userId ", SellerId);
      if (offer.includes(selectedCard)) {
        setOffer(offer.filter((card) => card !== selectedCard));
      } else {
        setOffer([...offer, selectedCard]);
      }
    } else if (selectedCard.UserId === BuyerId) {
      console.log("I am this seller userId ", BuyerId);
      if (wanted.includes(selectedCard)) {
        setWanted(wanted.filter((card) => card !== selectedCard));
      } else {
        setWanted([...wanted, selectedCard]);
      }
    }
  };

  const handleSubmitOffer = () => {
    console.log(
      "SellerId, BuyerId,offer, priceOfferAmount,comment,offer.shipping",
      SellerId,
      BuyerId,
      offer,
      priceOfferAmount,
      comment,
      Offer[0].Shipping
    );
    sendTradeOffer(
      SellerId,
      BuyerId,
      offer,
      priceOfferAmount,
      comment,
      Offer[0].Shipping
    );
    console.log("trade has been submitted");
    closeModal();
  };
  function buildCardDataArray(cards) {
    return cards.map((card) => card.userCardId);
  }

  function sendTradeOffer(
    SellerId,
    BuyerId,
    rawCards,
    Price,
    comment,
    shipping
  ) {
    console.log(
      "SellerId, BuyerId,rawCards, Price,comment,shipping",
      SellerId,
      BuyerId,
      rawCards,
      Price,
      comment,
      shipping
    );
    const userCardsId = buildCardDataArray(rawCards);

    console.log("SellerId,userCardsId,BuyerId", SellerId, userCardsId, BuyerId);
    // Log the data

    if (userCardsId.length > 0) {
      submitCounterOffer(
        SellerId,
        BuyerId,
        userCardsId,
        Price,
        comment,
        shipping
      );
      console.log("Offer Send");
    } else  console.log(t("Counter offer is not completed"));
 
  }
  function clearAll() {
    setOffer([]);
    setWanted([]);
    //setComment('');
    setHasReset(true);
    console.log("Everything as been reset");
  }

  function resetAll() {
    setOffer([]);
    setWanted([]);
    initialiseOriginalCardOffer();
    setPriceOfferAmount(Offer[0].Price);
    setHasReset(false);
    setShowSellerCards(false);
    //setComment('');
    console.log("Everything as been reset");
  }
  async function submitCounterOffer(SellerId, BuyerId, cards, Price, comment, shipping) {
    try {
      // Perform client-side validation
      if (
        SellerId == null ||
        BuyerId == null ||
        cards == null || cards.length === 0 ||
        Price == null ||
        shipping == null
      ) {
        throw new Error("All required fields must be filled.");
      }
  
      // Convert Price to a float (double in your database)
      const priceAsDouble = parseFloat(Price);
      if (isNaN(priceAsDouble) || priceAsDouble <= 0) {
        throw new Error(t("Price must be a positive number"));
      }
  
   

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/submitCounterOffer`,
        {
          SellerId: SellerId,
          BuyerId: BuyerId,
          UserCardIds: cards,
          Price: priceAsDouble,  // Send Price as a floating-point number
          Shipping: shipping,
          Comments: comment,
          ParentOfferId: Offer[0].TransactionId,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      // Handle the response from the server
      if (response.data.success) {
        toast.success(t("Counter offer submitted successfully!"));
        setCounteredTheOffer(SellerId, BuyerId, comment);
        resetAll();
      } else {
        toast.error(`${t("Failed to submit counter offer")}: ${response.data.error}`);
      }
    } catch (error) {
      toast.error(`${t("Failed to submit counter offer")}: ${error.message}`);
    }
  }
  
  
  async function setCounteredTheOffer(SellerId, BuyerId, comment) {
    try {
      console.log("SellerId, BuyerId", SellerId, BuyerId);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/counteredOffer`,
        {
          transactionId: Offer[0].TransactionId,
          SellerId: SellerId,
          BuyerId: BuyerId,
          AnswerComments: comment,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      if (response.data.success) {
        // Offer was successfully set to countered
        console.log("Offer set to countered");
      } else {
        console.error("Failed to set offer to countered:", response.data.error);
      }
    } catch (error) {
      console.error("Error countering offer:", error.message || error);
    }
  }
  

  const toggleUserCards = () => {
    setShowSellerCards(!showSellerCards);
  };

  const handlePriceOfferChange = (event) => {
    setPriceOfferAmount(event.target.value);
  };

  const ShowCompleteCard = ({ formData }) => {
    // Ensure this matches the structure and class names in your SCSS
    console.log("current card sale modal formdata", formData);
    return (
      <div className="cardcontentForm">
        <div className="card">
          <div className="img">
            <img
              className="card-image"
              src={formData.Image}
              alt="Card Preview"
              style={{ width: "200px", height: "300px" }}
            />
            <div className="filter"></div>
            <div className="card-isWhat">
              {formData.IsRookie === 1 && (
                <div className="patch spe">
                  <p className="strong">RC</p>
                </div>
              )}
              {formData.IsPatch === 1 && (
                <div className="patch">
                  <p>Patch</p>
                </div>
              )}
              {formData.IsJersey === 1 && (
                <div className="patch">
                  <p>Jersey</p>
                </div>
              )}
              {formData.IsAuto === 1 && (
                <div className="patch">
                  <p>Auto</p>
                </div>
              )}
              {formData.IsTribute === 1 && (
                <div className="patch">
                  <p>Tribute</p>
                </div>
              )}
            </div>
          </div>
          <div className="txt">
            <div className="justify">
              <h4 className="card-name">{formData.Name}</h4>

              <p className="card-IDcard ">#{formData.NumberBehind}</p>
            </div>
            <p className="card-set">{formData.SetName}</p>
            <div className="flex-h">
              <p className="card-variation">{`${formData.cardName} - ${formData.variationName}`}</p>
              {formData.Numbered && formData.Numbered !== "0" &&formData.Numbered !==0 ? (
                <p className="card-numbered"> / {formData.Numbered} </p>
              ) : null}
            </div>
            <div className="flex-h">
              {/* <div className="justify bottom"> */}
              <h4 className="card-value">{formData.Price}$</h4>
              {/* CTA section, if needed */}

              <div className="card-isfor">
                {formData.isForSale ===1 && (
                  <div className="patch ">
                    <p>{t('ForSale')}</p>
                  </div>
                )}
                {formData.isPC ===1 && (
                  <div className="patch ">
                    <p>PC</p>
                  </div>
                )}
                {formData.isForTrade ===1 && (
                  <div className="patch">
                    <p>{t('ForTrade')}</p>
                  </div>
                )}
                {formData.isOnEbay ===1 && (
                  <div className="patch">
                    <p>{t('OnEbay')}</p>
                  </div>
                )}
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
        {/* {formData.ImageBack && (
                    <div className="mt-2 text-left">
                      <label>Back</label>
                      <img src={formData.ImageBack} alt="Selected" className="card-image" />
                    </div>
                  )} */}
      </div>
    );
  };


  const generatePriceTable = (price, shipping) => {
    return (
      <div className="price-table" style={{
        color: "white",
        border: "1px solid #ccc",
        padding: "20px",
        borderRadius: "5px",
        backgroundColor: "black",
      }}>
        <table>
          <tbody>
            <tr>
              <td>{t("Price")}:</td>
              <td>{price}$</td>
            </tr>
            <tr>
              <td><label>{t("Offer")}($):</label></td>
              <td>
                <input
                  type="number"
                  value={priceOfferAmount}
                  onChange={handlePriceOfferChange}
                  style={{ border: "1px solid #000", padding: "5px", width: "35%" }}
                />
              </td>
            </tr>
            <tr>
              <td>{t("Shipping")}:</td>
              <td colSpan="2">{shipping}$</td>
            </tr>
            <tr className="total-row">
              <td>{t("Total")}:</td>
              <td colSpan="2">{price + shipping}$</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };



  return (
    <div>
      {/* <button onClick={openModal}>Trade</button> */}

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          content: {
            width: "90%",
            margin: "auto",
            marginTop: "100px",
            backgroundColor: "black",
            color: "white",
          },
        }}
      >
        <div>
          {SellerId === userId ? (
            <div>
              <h2>{t("Respond To Buyer CounterOffer")}</h2>
              
              <div className="flex-h" style={{marginRight:'15px'}}>

              <button onClick={toggleUserCards}>
                  {!showSellerCards ? t("Add cards") : t("Hide your cards")}
                </button>
                <button onClick={clearAll}>{t("Clear")}</button>
                <button onClick={resetAll}>{t("Reset")}</button>

              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    marginRight: "20px",
                    color: "white",
                    border: "1px solid #ccc",
                    padding: "10px",
                    borderRadius: "5px",
                    // backgroundColor: "#f9f9f9",
                    backgroundColor: "black",
                  }}
                >
                  <div className="flex-h">
                    <div>
                      <h3>{t("You give")}</h3>
                      {/* <p>Offer Value: {getOfferValueSum()} TV($)</p> */}
                      {offer.length > 0 ? (
                        offer.map((card, index) => (
                          <span
                            key={index}
                            onClick={() => handleCardSelect(card)}
                            style={{
                              cursor: "pointer",
                              border: offer.includes(card)
                                ? "2px solid #00f"
                                : "2px solid #000",
                              padding: "5px",
                              margin: "5px",
                              display: "inline-block",
                              minHeight: "300px",
                              maxWidth:'250px'
                            }}
                          >
                            <ShowCompleteCard formData={card} />
                          </span>
                        ))
                      ) : (
                        <span>{t("No offer yet")}</span>
                      )}
                    </div>

                    {/* VS */}
                    <div style={{ margin: "0 20px" }}>
                      <h1>{t("VS")}</h1>
                    </div>

                    {/* Wanted Cards */}
                    <div
                      style={{
                        marginLeft: "20px",
                        borderLeft: "2px solid #000",
                        paddingLeft: "20px",
                      }}
                    >
                      <h3>{t("You receive")}</h3>

                      
                        <div>
                          {generatePriceTable(Offer[0].Price, Offer[0].Shipping)}
                        </div>
                     
                     
                    </div>
                  </div>{" "}
                </div>

                {/* Cards List */}
                <p>
                  {!showSellerCards ? (
                    <></>
                  ) : (
                    sellerCards.map((card, index) => (
                      <span
                        key={index}
                        onClick={() => handleCardSelect(card)}
                        style={{
                          cursor: "pointer",
                          border: offer.includes(card)
                            ? "2px solid #00f"
                            : "2px solid #000",
                          padding: "5px",
                          margin: "5px",
                          display: "inline-block",
                          minHeight: "300px",
                        }}
                      >
                        <ShowCompleteCard formData={card} />
                      </span>
                    ))
                  )}
                </p>
              </div>
            </div>
          ) : (
            <>
              <h2>{t("Respond To Seller CounterOffer")}</h2>

              <div className="flex-h" >
              
              <button onClick={toggleUserCards} style={{marginRight:'15px'}}>
                {!showSellerCards ? "Add cards" : `Hide Seller's card`}
              </button>

              <button onClick={clearAll} style={{marginRight:'15px'}}>{t("Clear")} </button>
              <button onClick={resetAll}>{t("Reset")} </button>

              </div>
              <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                marginRight: "20px",
                color: "white",
                border: "1px solid #ccc",
                padding: "10px",
                borderRadius: "5px",
                // backgroundColor: "#f9f9f9",
                backgroundColor:'black',
              }}
            >

<div className="flex-h">

                  
                   
                    {/* <p>Offer Value: {getOfferValueSum()} TV($)</p> */}
                  
                      <div>
                         <h3>{t("You give")}</h3>
                            {generatePriceTable(45,25)} 
                      </div>
                  
                  

                    {/* VS */}
                    <div style={{ margin: "0 20px" }}>
                      <h1>{t("VS")}</h1>
                    </div>

                    {/* Wanted Cards */}
                    <div
                      style={{
                        marginLeft: "20px",
                        borderLeft: "2px solid #000",
                        paddingLeft: "20px",
                      }}
                    >
                      <h3>{t("You receive")}</h3>

                      {offer.length > 0 ? (
                        offer.map((card, index) => (
                          <span
                            key={index}
                            onClick={() => handleCardSelect(card)}
                            style={{
                              cursor: "pointer",
                              border: offer.includes(card)
                                ? "2px solid #00f"
                                : "2px solid #000",
                              padding: "5px",
                              margin: "5px",
                              display: "inline-block",
                              minHeight: "435px",
                            }}
                          >
                            <ShowCompleteCard formData={card} />
                          </span>
                        ))
                      ) : (
                        <span>{t("No offer yet")}</span>
                      )}
                    </div>
                
                  </div>
                </div>{" "}
              </div>

              {/* Cards List */}
              <p>
                {!showSellerCards ? (
                  <></>
                ) : (
                  sellerCards.map((card, index) => (
                    <span
                      key={index}
                      onClick={() => handleCardSelect(card)}
                      style={{
                        cursor: "pointer",
                        border: offer.includes(card)
                          ? "2px solid #00f"
                          : "2px solid #000",
                        padding: "5px",
                        margin: "5px",
                        display: "inline-block",
                        minHeight: "300px",
                      }}
                    >
                      <ShowCompleteCard formData={card} />
                    </span>
                  ))
                )}
              </p>
            </>
          )}

<div style={{display:'flex', justifyContent:'center'}}>
          <label>
            {t("Comment")}:
            </label>
            <textarea
              value={comment}
              onChange={handleCommentChange}
              maxLength={254}
              rows={4}
              cols={50}
              placeholder={t("Write a comment for the seller...")}
            />
         
       
          
          <button onClick={handleSubmitOffer} style={{marginLeft:'15px'}} disabled={offer.length === 0}>
            {t("Send Offer")}
          </button>
          </div>

        </div>
        <button onClick={closeModal}>{t("Close")}</button> 
      </Modal>
    </div>
  );
};

export default ViewMakeCounterOffer;
